import { CSSProperties } from 'react';

import createSvgIcon from 'shared/utils/createSvgIcon';

const styles: CSSProperties = {
  stroke: 'currentcolor',
  strokeLinecap: 'round',
  strokeMiterlimit: 10,
  strokeWidth: 2,
  fill: 'none',
};

export default createSvgIcon(
  <g>
    <path
      d="M5.08,16H3.86a2.59,2.59,0,0,1-2.58-2.58V7.71A2.59,2.59,0,0,1,3.86,5.13H5.08"
      style={styles}
    />
    <path
      d="M14.92,5.13h1.22a2.59,2.59,0,0,1,2.58,2.58h0v5.72A2.59,2.59,0,0,1,16.14,16H14.92"
      style={styles}
    />
    <rect x="5.08" y="11.41" width="9.83" height="6.76" style={styles} />
    <path
      d="M5.08,1.83H11a3.89,3.89,0,0,1,3.89,3.88v2H5.08V1.83Z"
      style={styles}
    />
  </g>,
  '0 0 20 20'
);
